/*
  Barra fixa de compra (sections/sticky-add-to-cart.liquid, protegida): o "Comprar" e a miniatura
  levam ao começo da área de compra (título, preço e opções), logo abaixo do cabeçalho, em vez do
  topo da página. Vale para toda página de produto (carregado por sections/main-product.liquid).
  O clique é tratado antes do script da barra; os arquivos dela não mudam.
*/
(function () {
  'use strict';

  if (window.haloBarraCompra) return;
  window.haloBarraCompra = true;

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.sticky-atc [data-sticky-atc-scroll]');
    if (!trigger) return;
    var info = document.querySelector('xo-product .xo-product-info');
    if (!info) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var header = document.querySelector('[data-halo-header-bar]') || document.querySelector('.xo-header__inner');
    var offset = (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + 12;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: info.getBoundingClientRect().top + window.pageYOffset - offset, behavior: reduce ? 'auto' : 'smooth' });
  }, true);
})();
